import { render, staticRenderFns } from "./zTomIndex.vue?vue&type=template&id=159e5dce&scoped=true&"
import script from "./zTomIndex.vue?vue&type=script&lang=js&"
export * from "./zTomIndex.vue?vue&type=script&lang=js&"
import style0 from "./zTomIndex.vue?vue&type=style&index=0&id=159e5dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159e5dce",
  null
  
)

export default component.exports